var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 904,
    height: 196,
    viewBox: "0 0 904 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 904,
    height: 196,
    rx: 17.5817,
    fill: "#1D113E"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 855.264,
    y: -36,
    width: 34.0929,
    height: 159.015,
    rx: 17.0465,
    transform: "rotate(45 855.264 -36)",
    fill: "#7951F9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.14,
    x: 915.916,
    y: -34.931,
    width: 37.4629,
    height: 159.015,
    rx: 18.7315,
    transform: "rotate(45 915.916 -34.931)",
    fill: "#7951F9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 34.0929,
    height: 159.015,
    rx: 17.0465,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 829.142 101)",
    fill: "#7951F9"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.14,
    width: 37.4629,
    height: 159.015,
    rx: 18.7315,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 768.49 102.069)",
    fill: "#7951F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959 182H0V210H959V182Z",
    fill: "url(#paint0_linear_38_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959 182H0V210H959V182Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: -14.1686,
    y: -46.7351,
    width: 189.941,
    height: 174.005,
    rx: 10,
    transform: "rotate(32.3981 -14.1686 -46.7351)",
    fill: "#E6DEFF",
    fillOpacity: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: -50.0615,
    y: -26.3479,
    width: 180.514,
    height: 165.369,
    rx: 10,
    transform: "rotate(32.3981 -50.0615 -26.3479)",
    fill: "#E6DEFF",
    fillOpacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2188 93.2422L60.8672 112.5H55.3008L47.8398 84.3164H53.9531L58.3867 104.727H58.543L63.8164 84.3164H68.7969L74.0703 104.727H74.2266L78.6797 84.3164H84.793L77.3125 112.5H71.7461L66.3945 93.2422H66.2188ZM92.918 108.711C95.3984 108.711 97.4492 107.09 97.4492 104.824V103.301L93.0352 103.574C90.9062 103.73 89.6953 104.688 89.6953 106.172C89.6953 107.734 90.9844 108.711 92.918 108.711ZM91.043 112.832C87.0586 112.832 84.0312 110.254 84.0312 106.484C84.0312 102.676 86.9609 100.469 92.1758 100.156L97.4492 99.8438V98.457C97.4492 96.5039 96.082 95.3711 93.9336 95.3711C91.8047 95.3711 90.457 96.4258 90.1836 97.9688H84.9688C85.1836 93.9062 88.6406 91.1133 94.1875 91.1133C99.5586 91.1133 103.055 93.8867 103.055 98.1055V112.5H97.5469V109.297H97.4297C96.2578 111.523 93.6602 112.832 91.043 112.832ZM106.746 112.5V91.5625H112.254V95.293H112.371C113.484 92.6953 115.691 91.1719 118.914 91.1719C123.562 91.1719 126.18 94.1016 126.18 99.0039V112.5H120.477V100.195C120.477 97.4609 119.188 95.8984 116.629 95.8984C114.07 95.8984 112.449 97.7734 112.449 100.488V112.5H106.746ZM131.316 86.7383H137.02V91.5625H140.887V95.8594H137.02V105.879C137.02 107.48 137.801 108.242 139.48 108.242C139.988 108.242 140.516 108.203 140.867 108.145V112.344C140.281 112.48 139.305 112.578 138.152 112.578C133.23 112.578 131.316 110.938 131.316 106.855V95.8594H128.367V91.5625H131.316V86.7383ZM153.465 86.7383H159.168V91.5625H163.035V95.8594H159.168V105.879C159.168 107.48 159.949 108.242 161.629 108.242C162.137 108.242 162.664 108.203 163.016 108.145V112.344C162.43 112.48 161.453 112.578 160.301 112.578C155.379 112.578 153.465 110.938 153.465 106.855V95.8594H150.516V91.5625H153.465V86.7383ZM175.457 112.949C169.129 112.949 165.086 108.887 165.086 102.012C165.086 95.2344 169.188 91.1133 175.457 91.1133C181.727 91.1133 185.828 95.2148 185.828 102.012C185.828 108.906 181.785 112.949 175.457 112.949ZM175.457 108.594C178.25 108.594 180.027 106.23 180.027 102.031C180.027 97.8711 178.23 95.4688 175.457 95.4688C172.684 95.4688 170.867 97.8711 170.867 102.031C170.867 106.23 172.645 108.594 175.457 108.594ZM198.23 86.7383H203.934V91.5625H207.801V95.8594H203.934V105.879C203.934 107.48 204.715 108.242 206.395 108.242C206.902 108.242 207.43 108.203 207.781 108.145V112.344C207.195 112.48 206.219 112.578 205.066 112.578C200.145 112.578 198.23 110.938 198.23 106.855V95.8594H195.281V91.5625H198.23V86.7383ZM218.816 108.711C221.297 108.711 223.348 107.09 223.348 104.824V103.301L218.934 103.574C216.805 103.73 215.594 104.688 215.594 106.172C215.594 107.734 216.883 108.711 218.816 108.711ZM216.941 112.832C212.957 112.832 209.93 110.254 209.93 106.484C209.93 102.676 212.859 100.469 218.074 100.156L223.348 99.8438V98.457C223.348 96.5039 221.98 95.3711 219.832 95.3711C217.703 95.3711 216.355 96.4258 216.082 97.9688H210.867C211.082 93.9062 214.539 91.1133 220.086 91.1133C225.457 91.1133 228.953 93.8867 228.953 98.1055V112.5H223.445V109.297H223.328C222.156 111.523 219.559 112.832 216.941 112.832ZM232.781 112.5V84.3164H238.484V112.5H232.781ZM248.25 99.9609L255.359 91.5625H261.824L253.836 100.547L262.215 112.5H255.652L249.656 103.984L248.172 105.586V112.5H242.469V84.3164H248.172V99.9609H248.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32 87.0898H278.559V91.9531H282.465V95.293H278.559V106.621C278.559 108.398 279.34 109.199 281.059 109.199C281.488 109.199 282.172 109.16 282.445 109.102V112.441C281.977 112.559 281.039 112.637 280.102 112.637C275.941 112.637 274.32 111.055 274.32 107.09V95.293H271.332V91.9531H274.32V87.0898Z",
    fill: "url(#paint1_linear_38_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.262 112.891C288.383 112.891 284.516 108.848 284.516 102.227C284.516 95.625 288.402 91.582 294.262 91.582C300.121 91.582 304.008 95.625 304.008 102.227C304.008 108.848 300.141 112.891 294.262 112.891ZM294.262 109.414C297.582 109.414 299.711 106.797 299.711 102.227C299.711 97.6758 297.562 95.0586 294.262 95.0586C290.961 95.0586 288.812 97.6758 288.812 102.227C288.812 106.797 290.961 109.414 294.262 109.414Z",
    fill: "url(#paint2_linear_38_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.625 87.0898H320.863V91.9531H324.77V95.293H320.863V106.621C320.863 108.398 321.645 109.199 323.363 109.199C323.793 109.199 324.477 109.16 324.75 109.102V112.441C324.281 112.559 323.344 112.637 322.406 112.637C318.246 112.637 316.625 111.055 316.625 107.09V95.293H313.637V91.9531H316.625V87.0898Z",
    fill: "url(#paint3_linear_38_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.402 112.5V84.3164H332.582V95.3906H332.68C333.812 92.9883 336.059 91.6016 339.184 91.6016C343.695 91.6016 346.391 94.6094 346.391 99.2578V112.5H342.152V100.078C342.152 97.0508 340.629 95.2344 337.66 95.2344C334.535 95.2344 332.621 97.3828 332.621 100.625V112.5H328.402Z",
    fill: "url(#paint4_linear_38_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.066 94.9805C356.117 94.9805 354.047 97.2266 353.832 100.332H364.105C364.008 97.1875 362.016 94.9805 359.066 94.9805ZM364.086 106.465H368.09C367.504 110.215 363.949 112.891 359.242 112.891C353.207 112.891 349.555 108.809 349.555 102.324C349.555 95.8789 353.266 91.582 359.066 91.582C364.77 91.582 368.324 95.6055 368.324 101.836V103.281H353.812V103.535C353.812 107.109 355.961 109.473 359.34 109.473C361.742 109.473 363.52 108.262 364.086 106.465Z",
    fill: "url(#paint5_linear_38_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.961 87.0898H385.199V91.9531H389.105V95.293H385.199V106.621C385.199 108.398 385.98 109.199 387.699 109.199C388.129 109.199 388.812 109.16 389.086 109.102V112.441C388.617 112.559 387.68 112.637 386.742 112.637C382.582 112.637 380.961 111.055 380.961 107.09V95.293H377.973V91.9531H380.961V87.0898Z",
    fill: "url(#paint6_linear_38_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.668 94.9805C397.719 94.9805 395.648 97.2266 395.434 100.332H405.707C405.609 97.1875 403.617 94.9805 400.668 94.9805ZM405.688 106.465H409.691C409.105 110.215 405.551 112.891 400.844 112.891C394.809 112.891 391.156 108.809 391.156 102.324C391.156 95.8789 394.867 91.582 400.668 91.582C406.371 91.582 409.926 95.6055 409.926 101.836V103.281H395.414V103.535C395.414 107.109 397.562 109.473 400.941 109.473C403.344 109.473 405.121 108.262 405.688 106.465Z",
    fill: "url(#paint7_linear_38_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.395 109.512C423.344 109.512 425.648 107.48 425.648 104.805V103.184L420.59 103.496C418.07 103.672 416.645 104.785 416.645 106.543C416.645 108.34 418.129 109.512 420.395 109.512ZM419.223 112.852C415.199 112.852 412.387 110.352 412.387 106.66C412.387 103.066 415.141 100.859 420.023 100.586L425.648 100.254V98.6719C425.648 96.3867 424.105 95.0195 421.527 95.0195C419.086 95.0195 417.562 96.1914 417.191 98.0273H413.207C413.441 94.3164 416.605 91.582 421.684 91.582C426.664 91.582 429.848 94.2188 429.848 98.3398V112.5H425.805V109.121H425.707C424.516 111.406 421.918 112.852 419.223 112.852Z",
    fill: "url(#paint8_linear_38_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.949 112.5V91.9531H437.973V95.4102H438.07C438.988 93.125 441.137 91.6016 443.91 91.6016C446.762 91.6016 448.832 93.0664 449.652 95.625H449.75C450.805 93.125 453.227 91.6016 456.156 91.6016C460.219 91.6016 462.875 94.2969 462.875 98.3789V112.5H458.637V99.3945C458.637 96.7383 457.211 95.2148 454.711 95.2148C452.211 95.2148 450.473 97.0703 450.473 99.668V112.5H446.332V99.082C446.332 96.7188 444.828 95.2148 442.445 95.2148C439.945 95.2148 438.168 97.168 438.168 99.8047V112.5H433.949Z",
    fill: "url(#paint9_linear_38_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.941 91.875C466.117 87.4414 469.145 84.082 474.809 84.082C479.965 84.082 483.441 87.1484 483.441 91.3281C483.441 94.3555 481.918 96.4844 479.34 98.0273C476.82 99.5117 476.098 100.547 476.098 102.559V103.75H472.055L472.035 102.188C471.938 99.4336 473.129 97.6758 475.805 96.0742C478.168 94.6484 479.008 93.5156 479.008 91.5039C479.008 89.2969 477.27 87.6758 474.594 87.6758C471.898 87.6758 470.16 89.2969 469.984 91.875H465.941ZM474.105 112.793C472.68 112.793 471.547 111.699 471.547 110.273C471.547 108.848 472.68 107.754 474.105 107.754C475.57 107.754 476.684 108.848 476.684 110.273C476.684 111.699 475.57 112.793 474.105 112.793Z",
    fill: "url(#paint10_linear_38_58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707,
    y: 78,
    width: 147,
    height: 40,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.982 104.195C744.74 104.195 742.693 101.961 742.693 98.3594V98.3516C742.693 94.75 744.748 92.5312 747.982 92.5312C750.576 92.5312 752.482 94.1484 752.779 96.4453L752.787 96.5234H750.81L750.771 96.375C750.443 95.0859 749.451 94.2812 747.982 94.2812C746.013 94.2812 744.756 95.8516 744.756 98.3516V98.3594C744.756 100.867 746.021 102.445 747.982 102.445C749.42 102.445 750.427 101.672 750.795 100.281L750.818 100.203H752.795L752.779 100.281C752.49 102.594 750.576 104.195 747.982 104.195ZM757.795 104.164C755.357 104.164 753.787 102.539 753.787 99.8594V99.8438C753.787 97.1875 755.381 95.5469 757.787 95.5469C760.201 95.5469 761.802 97.1719 761.802 99.8438V99.8594C761.802 102.547 760.224 104.164 757.795 104.164ZM757.802 102.594C759.029 102.594 759.818 101.594 759.818 99.8594V99.8438C759.818 98.1172 759.021 97.125 757.787 97.125C756.576 97.125 755.771 98.125 755.771 99.8438V99.8594C755.771 101.602 756.56 102.594 757.802 102.594ZM763.052 104V95.7188H764.998V97.0156H765.037C765.467 96.125 766.31 95.5469 767.568 95.5469C769.388 95.5469 770.427 96.7188 770.427 98.6406V104H768.482V99.0312C768.482 97.8516 767.935 97.1875 766.826 97.1875C765.709 97.1875 764.998 98 764.998 99.1953V104H763.052ZM775.068 104.164C773.334 104.164 772.513 103.461 772.513 101.758V97.2188H771.342V95.7188H772.513V93.6172H774.49V95.7188H776.029V97.2188H774.49V101.594C774.49 102.406 774.849 102.664 775.56 102.664C775.748 102.664 775.896 102.641 776.029 102.633V104.094C775.802 104.125 775.459 104.164 775.068 104.164ZM779.701 104.141C778.045 104.141 776.927 103.117 776.927 101.641V101.625C776.927 100.156 778.068 99.2734 780.076 99.1484L782.24 99.0156V98.4453C782.24 97.6094 781.693 97.1016 780.709 97.1016C779.787 97.1016 779.224 97.5312 779.099 98.1406L779.084 98.2109H777.279L777.287 98.1172C777.404 96.6484 778.677 95.5469 780.779 95.5469C782.849 95.5469 784.185 96.6406 784.185 98.3047V104H782.24V102.727H782.193C781.717 103.594 780.795 104.141 779.701 104.141ZM778.865 101.562C778.865 102.242 779.427 102.656 780.279 102.656C781.396 102.656 782.24 101.914 782.24 100.93V100.305L780.349 100.422C779.388 100.484 778.865 100.898 778.865 101.555V101.562ZM789.412 104.164C786.951 104.164 785.412 102.508 785.412 99.8516V99.8438C785.412 97.2031 786.974 95.5469 789.388 95.5469C791.568 95.5469 792.927 96.9297 793.045 98.5859L793.052 98.6484H791.217L791.201 98.5781C791.037 97.7734 790.443 97.125 789.412 97.125C788.185 97.125 787.396 98.1641 787.396 99.8594V99.8672C787.396 101.594 788.193 102.594 789.42 102.594C790.404 102.594 791.029 102.008 791.209 101.141L791.224 101.07H793.06L793.052 101.125C792.904 102.852 791.506 104.164 789.412 104.164ZM797.302 104.164C795.568 104.164 794.748 103.461 794.748 101.758V97.2188H793.576V95.7188H794.748V93.6172H796.724V95.7188H798.263V97.2188H796.724V101.594C796.724 102.406 797.084 102.664 797.795 102.664C797.982 102.664 798.131 102.641 798.263 102.633V104.094C798.037 104.125 797.693 104.164 797.302 104.164ZM805.623 104.164C803.802 104.164 802.763 102.992 802.763 101.07V95.7188H804.709V100.688C804.709 101.859 805.256 102.523 806.365 102.523C807.482 102.523 808.193 101.719 808.193 100.516V95.7188H810.138V104H808.193V102.703H808.154C807.724 103.586 806.873 104.164 805.623 104.164ZM814.974 104.164C812.802 104.164 811.56 103.133 811.388 101.594L811.381 101.523H813.295L813.31 101.594C813.459 102.305 813.998 102.727 814.982 102.727C815.927 102.727 816.498 102.344 816.498 101.734V101.727C816.498 101.227 816.209 100.945 815.349 100.75L813.974 100.445C812.388 100.094 811.592 99.3203 811.592 98.0938V98.0859C811.592 96.5703 812.912 95.5469 814.912 95.5469C816.974 95.5469 818.177 96.6797 818.248 98.1094L818.256 98.1953H816.443L816.435 98.1328C816.349 97.4688 815.818 96.9844 814.912 96.9844C814.052 96.9844 813.513 97.3828 813.513 97.9922V98C813.513 98.4766 813.834 98.7891 814.693 98.9844L816.076 99.2891C817.787 99.6719 818.451 100.344 818.451 101.547V101.555C818.451 103.117 817.006 104.164 814.974 104.164Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_58",
    x1: -84.0305,
    y1: 188.104,
    x2: -74.3702,
    y2: 291.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#735AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA637A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_58",
    x1: 279.392,
    y1: 90.9673,
    x2: 293.404,
    y2: 152.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38_58",
    x1: 279.392,
    y1: 90.9673,
    x2: 293.404,
    y2: 152.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38_58",
    x1: 279.392,
    y1: 90.9673,
    x2: 293.404,
    y2: 152.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_38_58",
    x1: 279.392,
    y1: 90.9673,
    x2: 293.404,
    y2: 152.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_38_58",
    x1: 279.392,
    y1: 90.9673,
    x2: 293.404,
    y2: 152.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_38_58",
    x1: 279.392,
    y1: 90.9673,
    x2: 293.404,
    y2: 152.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_38_58",
    x1: 279.392,
    y1: 90.9673,
    x2: 293.404,
    y2: 152.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_38_58",
    x1: 279.392,
    y1: 90.9673,
    x2: 293.404,
    y2: 152.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_38_58",
    x1: 279.392,
    y1: 90.9673,
    x2: 293.404,
    y2: 152.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_38_58",
    x1: 279.392,
    y1: 90.9673,
    x2: 293.404,
    y2: 152.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9577FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 904,
    height: 196,
    rx: 17.5817,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFooter);
export default __webpack_public_path__ + "static/media/home_footer.95874ab08ce85ed62a041cac021adcc8.svg";
export { ForwardRef as ReactComponent };